import React, { useEffect, useState } from 'react';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="fixed bottom-0 left-0 right-0 p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] bg-dark/95 backdrop-blur-md border-t border-gray-800 z-50 md:hidden shadow-[0_-4px_20px_rgba(0,0,0,0.5)] transition-all duration-300" style={{
    transform: isVisible ? 'translateY(0)' : 'translateY(100%)',
    opacity: isVisible ? 1 : 0,
    pointerEvents: isVisible ? 'auto' : 'none'
  }} data-id="element-253">
      <a href="#pricing" className="block w-full bg-brand-orange text-white font-bold py-3.5 px-6 rounded-xl text-center text-sm shadow-[0_0_20px_rgba(255,107,0,0.3)] active:scale-[0.98] transition-transform" data-id="element-254">
        COMPRAR AHORA — desde $19.990
      </a>
    </div>;
}